module.exports = __webpack_public_path__ + "img/map-download02.ee7d9ae7.jpg";